/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable local-rules/no-direct-import */
/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useMemo } from 'react';

import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';

import FuturesTradingViewContainer from './FuturesTradingViewContainer';
import { getContainerType } from './helper';
import OptionsTradingViewContainer from './OptionsTradingViewContainer';
import TrackerTradingViewContainer from './TrackerTradingViewContainer';
import DefaultTradingViewContainer from './TradingViewContainer';

const TradingViewContainer = (props: { match: { params: any }; fullScreen: boolean }) => {
  const selectedProduct = useAppSelector(state => selectedProductSelector(state));

  const isNewTab = window.location.href.indexOf('/app/tradingview') > -1;

  const containerType = useMemo(() => {
    if (isNewTab) {
      return 'default';
    }

    if (!selectedProduct?.contract_type) {
      return 'futures'; // Default to futures
    }
    return getContainerType(selectedProduct.contract_type);
  }, [selectedProduct?.contract_type]);

  console.log(
    'DEBUG MAIN: Rendering container type:',
    containerType,
    'for contract:',
    selectedProduct?.contract_type
  );

  // Conditionally render the appropriate container
  if (containerType === 'options') {
    return <OptionsTradingViewContainer {...props} />;
  }

  if (containerType === 'tracker') {
    return <TrackerTradingViewContainer {...props} />;
  }

  if (containerType === 'futures') {
    return <FuturesTradingViewContainer {...props} />;
  }

  return <DefaultTradingViewContainer {...props} />;
};

export default memo(TradingViewContainer);
